import useDebouncedAction from "@/hooks/useDebouncedAction";
import { convertSentenceColorToRbgColor } from "@/utils/functions/grammar";
import { Box, Button, Popover } from "@mui/material";
import _ from "lodash";
import { useEffect, useState } from "react";
import { ColorResult, SketchPicker } from "react-color";

interface IColorPicker {
  color: SentenceColor;
  // eslint-disable-next-line no-unused-vars
  handleChangeColor: (color: SentenceColor) => void;
}

const ColorPicker: React.FC<IColorPicker> = ({ color, handleChangeColor }) => {
  const [currentColor, setCurrentColor] = useState<SentenceColor>(color);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.target as HTMLElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (newColor: ColorResult) => {
    setCurrentColor({ r: newColor.rgb.r, g: newColor.rgb.g, b: newColor.rgb.b });
  };

  const open = Boolean(anchorEl);
  const id = open ? "color-picker-popover" : undefined;

  useDebouncedAction(
    [currentColor],
    () => {
      if (!_.isEqual(currentColor, color)) handleChangeColor(currentColor);
    },
    300
  );

  useEffect(() => {
    if (!_.isEqual(currentColor, color)) setCurrentColor(color);
  }, [color]);

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        style={{ backgroundColor: convertSentenceColorToRbgColor(currentColor), color: "#fff" }}>
        Choisissez une couleur
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}>
        <Box p={2}>
          <SketchPicker disableAlpha color={currentColor} onChange={handleColorChange} />
        </Box>
      </Popover>
    </>
  );
};

export default ColorPicker;
